module.exports = __webpack_public_path__ + "img/ewm.c071e5d5.png";